import { render, staticRenderFns } from "./AdminControlPoints.vue?vue&type=template&id=421231df&"
import script from "./AdminControlPoints.vue?vue&type=script&lang=js&"
export * from "./AdminControlPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports